import React, { useMemo } from 'react';

import type { HomePage as HomePageType } from '../../types/entities';
import Blocks from '../blocks/Blocks';
import HomeSplash from '../partials/HomeSplash';
import PageMeta from '../partials/PageMeta';

import styles from '../../../styles/pages/home.module.css';

interface HomePageProps {
    page: HomePageType;
}

function HomePage({ page = null }: HomePageProps) {
    const { url = null, title = null, share = null, blocks = [] } = page || {};
    const topBlocks = useMemo(() => (blocks || []).slice(0, 1), [blocks]);
    const otherBlocks = useMemo(() => (blocks || []).slice(1), [blocks]);

    return (
        <div className={styles.container}>
            <PageMeta url={url} title={title} isHome {...share} />
            <HomeSplash page={page} blocks={topBlocks} />
            <Blocks page={page} blocks={otherBlocks} blocksAreSections withoutPadding />
        </div>
    );
}

export default HomePage;
